export const PANEL_EMBEDDING_MINIMIZE_TOGGLE_TEST_ID =
  "panel-embedding-minimize-toggle";
